import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateCreateNewMessage = {
  createNewMessage: { data: null, loading: false, error: null },
};

export const createNewMessage = createAsyncThunk('user/createNewMessage', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/chat/chats`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCreateNewMessage = {
  [createNewMessage.pending]: (state) => {
    // state.createNewMessage.data = null;
    state.createNewMessage.loading = true;
    state.createNewMessage.error = null;
  },
  [createNewMessage.fulfilled]: (state, action) => {
    state.createNewMessage.loading = false;
    state.createNewMessage.data = action.payload;
    state.createNewMessage.error = null;
  },
  [createNewMessage.rejected]: (state, action) => {
    state.createNewMessage.loading = false;
    state.createNewMessage.error = action.payload;
  },
};
